import { FC } from 'react'
import { RootCodeState } from '@dtx-company/inter-app/src/redux/types'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { LoggedOutGeneratorFooter as FooterComponent } from './LoggedOutGeneratorFooter/LoggedOutGeneratorFooter'

export const Footer: FC = () => {
  const { hideFooter } = useCodeSelector((state: RootCodeState) => state.settings)
  return <>{!hideFooter && <FooterComponent />}</>
}
